import Gallery from './gallery'
import Map from './map'
import Toggler from './toggler'
import IconLoader from './icon'
import Pager from './pager'
import Header from './header'
import ExternalLink from './externalLink'
import InternetExplorer from './internetExplorer'
import Highchart from './highcharts'
import HistoryReveal from './history'
import Toast from './toast'
import Persons from './persons'
import ScrollToTopButton from './scrollToTopButton'

require('smoothscroll-polyfill').polyfill()

/**
 *
 */
export default class {
  /**
   *
   */
  constructor() {
    if (
      document.attachEvent
        ? document.readyState === 'complete'
        : document.readyState !== 'loading'
    ) {
      this.documentReady()
    } else {
      document.addEventListener(
        'DOMContentLoaded',
        this.documentReady.bind(this),
      )
    }
  }

  /**
   *
   */
  documentReady() {
    if (this.isIe11()) {
      document.body.classList.add('is-ie11')
    }
    if (this.isOldEdge()) {
      document.body.classList.add('is-old-edge')
    }

    this.initHeader()
    this.initIcons()
    this.initGalleries()
    this.initToggle()
    this.initMaps()
    this.initExternal()
    this.initCloser()
    this.initExplorer()
    this.initCharts()
    this.initHistory()
    this.initToast()
    this.initPersons()
    this.initScrollTopButton()
  }

  initHeader() {
    new Header(document.querySelector('.header'))
  }

  initExternal() {
    new ExternalLink()
  }

  initIcons() {
    new IconLoader(
      '/themes/fenaco/dist/assets/icons.svg',
      'main',
      this.isIe11(),
    )
  }

  initScrollTopButton() {
    new ScrollToTopButton()
  }

  /**
   *
   */
  initGalleries() {
    const galleries = document.getElementsByClassName('gallery')
    for (let i = 0; i < galleries.length; i++) {
      new Gallery(galleries[i])
    }
  }

  /**
   *
   */
  initToggle() {
    const toggler = new Toggler()

    document
      .querySelector('.modal.-search')
      .addEventListener('click', (event) => {
        if (
          event.target.classList.contains('container') ||
          event.target.classList.contains('modal')
        ) {
          document.querySelector('.btn[data-class=search-open]').click()
        }
      })

    toggler.addTrigger('search', () => {
      window.setTimeout(() => {
        document.getElementById('edit-search-api-fulltext').focus()
      }, 200)
    })

    toggler.addTrigger('team', (target) => {
      const teasers = document.body.querySelectorAll('.teaser.-person')
      for (let i = 0; i < teasers.length; i++) {
        const teaser = teasers[i]
        if (teaser !== target) {
          teaser.classList.remove('toggled')
        }
      }
    })
  }

  /**
   *
   */
  initMaps() {
    const maps = document.getElementsByClassName('map')
    for (let i = 0; i < maps.length; i++) {
      new Map(maps[i])
    }
  }

  initHistory() {
    new HistoryReveal()
  }

  /**
   *
   */
  initCloser() {
    const pagers = document.querySelectorAll('.pager')
    for (let i = 0; i < pagers.length; i++) {
      new Pager(pagers[i])
    }
  }

  initCharts() {
    new Highchart()
  }

  initToast() {
    const toasts = document.querySelectorAll('[data-toast]')
    for (let i = 0; i < toasts.length; i++) {
      new Toast(toasts[i])
    }
  }

  initPersons() {
    const entries = document.querySelectorAll('[data-person]')
    if (entries.length > 0) {
      new Persons(entries)
    }
  }

  initExplorer() {
    if (this.isIe11()) {
      new InternetExplorer()
    }
  }

  isIe11() {
    return !!window.MSInputMethodContext && !!document.documentMode
  }

  isOldEdge() {
    return (
      navigator.userAgent.indexOf('Edge/16') > 0 ||
      navigator.userAgent.indexOf('Edge/17') > 0
    )
  }
}
